<template>
  <div id="vacancy" class="vacancy" v-loading.body="loading">
    <el-row style="height:100%">
      <el-col :span="24" style="height:100%;">
        <div style="padding:5px;">
          <el-input placeholder="Поиск..." v-model="search" @change="changeSearchValue" style="width:50%;">
          </el-input>
          <el-button style="float:right;height:36px;" type="primary" icon="plus" @click="addVacancy" v-if="isOperator">
            Добавить конкурс
          </el-button>
        </div>
        <div style="height:100%;padding:5px;">
          <el-table
            ref="vacancyData"
            :data="vacancies"
            border
            highlight-current-row
            v-bind:height="resultsTableHeight"
            @current-change="handleVacancySelect"
            style="width: 100%; height: 100%;" header-cell-class-name="default-header-color">
            <el-table-column type="expand">
              <template slot-scope="props" style="text-align: justify; text-justify: inter-word;">
                <el-row>
                  <el-col :span="7" class="left-add-info">
                    Подача документов для участия в период:
                  </el-col>
                  <el-col :span="17" class="right-add-info">
                    {{ formatDate(props.row.dateDocumentsAppliedFrom) }} - {{ formatDate(props.row.dateDocumentsAppliedTo) }}
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" class="left-add-info">
                    Место проведения:
                  </el-col>
                  <el-col :span="17" class="right-add-info">
                    {{ props.row.place }}
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" class="left-add-info">
                    Контакты:
                  </el-col>
                  <el-col :span="17" class="right-add-info">
                    {{ props.row.contacts }}
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" class="left-add-info">
                    Предварительная дата проведения:
                  </el-col>
                  <el-col :span="17" class="right-add-info">
                    {{ formatDate(props.row.dateOfContestPreliminary) }}
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" class="left-add-info">
                    Дата проведенного конкурса:
                  </el-col>
                  <el-col :span="17" class="right-add-info">
                    {{ formatDate(props.row.dateOfContest) }}
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" class="left-add-info">
                    Статус конкурса:
                  </el-col>
                  <el-col :span="17" class="right-add-info">
                    {{ props.row.statusLabel }}
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" class="left-add-info">
                    Дата проведения второго этапа:
                  </el-col>
                  <el-col :span="17" class="right-add-info">
                    <div>
                      {{ formatDate(props.row.dateOfSecondStage) }}
                    </div>
                    <div style="padding-top: 10px;">
                      <span v-if="isCandidate">
                        <div>
                          <el-button
                            type="success"
                            icon="edit"
                            :disabled="!props.row.canApply"
                            @click="enroll(props.$index, props.row)" size="mini">Подать заявку</el-button>
                          <el-button
                            type="danger"
                            icon="edit"
                            :disabled="!props.row.canDecline"
                            @click="deny(props.$index, props.row)" size="mini">Отозвать заявку</el-button>
                          <span>
                            <b style="padding-left: 10px;">{{props.row.vacancyCandidateStatusLabel}}</b>
                          </span>
                        </div>
                        <div>
                          <b>Для просмотра и скачивания предзаполненного заявления нажмите <a target="_blank" @click="showApplication(props.row.uid)">здесь</a></b>
                        </div>
                      </span>
                      <span v-else>
                        <b> Кандидаты </b>
                      </span>
                    </div>
                  </el-col>
                </el-row>
                <el-row v-if="isOperator">
                  <el-col :span="7" class="left-add-info">
                    <span v-for="(item, index) in props.row.candidates">
                      <el-row :key="'candidate' + item.id">
                        <el-button type="text" @click="open(props.row.uid, item.candidateId)">{{ item.fullName }}</el-button>
                      </el-row>
                    </span>
                  </el-col>
                  <el-col :span="17" class="right-add-info">
                    <span v-for="(item, index) in props.row.candidates">
                      <el-row :key="'candidate' + item.id">
                        <el-button type="text" @click="open(props.row.uid, item.candidateId)">{{ item.statusString }}</el-button>
                      </el-row>
                    </span>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column
              property="position"
              label="Должность"
              class="grid-text-overflow">
              <template slot-scope="scope">
                <span style="width: 100%; text-align: justify; text-justify: inter-word;  white-space: normal; word-break: normal;">
                  {{ scope.row.position }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              property="comitteeLabel"
              label="Орган исполнительной власти"
              class="grid-text-overflow">
              <template slot-scope="scope">
                <span style="width: 100%; text-align: justify; text-justify: inter-word;  white-space: normal; word-break: normal;">
                  {{ scope.row.comitteeLabel }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Опубликован"
              property="datePublish"
              width="180"
              class="grid-text-overflow">
              <template slot-scope="scope">
                <el-icon name="time"></el-icon>
                <el-tooltip class="item" effect="dark" :content="formatDateWithHoursAndMinutes(scope.row.datePublish)" placement="top">
                  <span style="margin-left: 10px" class="grid-text-overflow">{{ formatDateWithHoursAndMinutes(scope.row.datePublish) }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
             label="Операции"
             width="140"
             v-if="isOperator"
             >
             <template slot-scope="scope">
               <el-button
                size="mini"
                icon="el-icon-edit"
                @click="editVacancy(scope.$index, scope.row)"></el-button>
               <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                @click="deleteVacancy(scope.$index, scope.row)"></el-button>
             </template>
           </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import layout from '../../api/helpers/layout'
  import grid from '../../api/helpers/grid'
  import rules from '../../api/rules/vacancy'
  import extension from '../../api/helpers/file'
  import html2pdf from 'html2pdf.js'
  import jsPDF from 'jspdf'

  export default {
    name: 'vacancy',
    data() {
      return {
        username: '',
        loading: false,
        search: '',
        isCandidate: false,
        vacancies: [],
        currentVacancy: {
          uid: '',
          position: '',
          comitteeId: null,
          comitteeLabel: '',
          comittee: { id: null, label: '' },
          datePublish: null,
          dateOfContestPreliminary: null,
          dateOfContest: null,
          dateDocumentsAppliedFrom: null,
          dateDocumentsAppliedTo: null,
          dateOfSecondStage: null,
          place: '',
          contacts: '',
          status: 0,
          statusLabel: '',
          contestType: null,
          contestTypeLabel: '',
          description: '',
          candidates: []
        },
        selectedVacancy: null,
        comittees: [],
        contesttypes: [],
        statuses: [],
        vacancyDialogVisible: false,
        resultsHeight: null,
        fileList: [],
        uploadUrl: '',
        vacancyToEnroll: null,
        uploadRequestHeaders: null,
        attachmentToUpload: null,
        docDialogVisible: false
      }
    },
    computed: {
      resultsTableHeight: function() {
        if(!this.resultsHeight) {
          let height = layout.getParentClientHeight();
          if(height)
            return height - 77;
        }
        return this.resultsHeight - 47;
      },
      isOperator: function() {
        return !this.isCandidate;
      },
      isStatusReadOnly: function(){
        return !(this.currentVacancy && this.currentVacancy.uid);
      },
      vacancyRules: function() {
        let r = rules.getVacancyRules()
        r.dateDocumentsAppliedFrom = this.dateDocumentsAppliedFrom;
        return r;
      }
    },
    methods: {
      handleVacancySelect(val) {
        this.selectedVacancy = val;
      },
      openVacancy() {

      },
      addVacancy() {
        //this.resetVacancy();
        //this.vacancyDialogVisible = true;
        this.$router.push(config.VACANCY_URL + '/0');
      },
      editVacancy(index, val) {
        //this.resetVacancy();
        this.selectedVacancy = val;
        //grid.assign(this.currentVacancy, this.selectedVacancy);
        //this.vacancyDialogVisible = true;
        this.$router.push(config.VACANCY_URL + '/' + this.selectedVacancy.uid);
      },
      deleteVacancy(index, val) {
        this.$confirm('Вы действительно хотите удалить конкурс?', 'Предупреждение', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }).then(() => {
          let self = this;
          let prefix = config.API_PREFIX;
          this.$gf.getOptions().then(options => {
            options.params = { };
            let uid = val.uid;
            self.$http.delete(`${prefix}vacancy/${uid}`, options).then(response => {
              this.fetchData();
              //this.$message.error('Вы успешно удалили конкурс');
              this.$message({
                message: 'Вы успешно удалили конкурс',
                type: 'success'
              });
            }).catch(data => {
              this.loading = false;
              self.$gf.checkError(data)
            });
          }).catch(err => this.$gf.catchOptions());
        }).catch(() => {

        });
      },
      acceptVacancy() {
        this.$refs['vacancy'].validate((valid) => {
          if (valid) {
            if(this.currentVacancy) {
              this.$gf.getOptions().then(options => {
                options.params = { };
                let self = this;
                let prefix = config.API_PREFIX;
                if(this.currentVacancy.uid === '') {
                  this.currentVacancy.datePublish = new Date();
                  self.$http.post(`${prefix}vacancy`, this.currentVacancy, options).then(response => {
                    this.fetchData();
                    this.vacancyDialogVisible = false;
                  }).catch(data => {
                    this.loading = false;
                    self.$gf.checkError(data)
                  });
                } else {
                  self.$http.put(`${prefix}vacancy`, this.currentVacancy, options).then(response => {
                    this.fetchData();
                    this.vacancyDialogVisible = false;
                  }).catch(data => {
                    this.loading = false;
                    self.$gf.checkError(data)
                  });
                }
              });
            }
          }
        });
      },
      cancelVacancy() {
        this.vacancyDialogVisible = false;
      },
      resetVacancy() {
        this.currentVacancy = {
          uid: '',
          position: '',
          comitteeId: null,
          comitteeLabel: '',
          comittee: { id: null, label: '' },
          datePublish: null,
          dateOfContestPreliminary: null,
          dateOfContest: null,
          dateDocumentsAppliedFrom: null,
          dateDocumentsAppliedTo: null,
          dateOfSecondStage: null,
          place: '',
          contacts: '',
          status: 0,
          statusLabel: '',
          contestType: null,
          contestTypeLabel: '',
          description: '',
          candidates: []
        };
      },
      enroll(index, val) {
        /*this.$confirm(`Вы действительно хотите подать заявку на конкурс на должность: '${val.position}' (Дата проведения конкурса: ${this.formatDate(val.dateOfContestPrelimenary)})?`, 'Информация', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Отмена',
          type: 'info'
        }).then(() => {
          let self = this;
          let prefix = config.API_PREFIX;
          this.vacancyToEnroll = val.uid;
          this.uploadUrl = `${config.API_PREFIX}vacancycandidate/${this.vacancyToEnroll}/attachments`;
          this.docDialogVisible = true;
        }).catch(() => {

        });*/
        this.$router.push(config.VACANCY_URL + '/view/' + val.uid);
      },
      deny(index, val) {
        this.$confirm(`Вы действительно отозвать заявку на конкурс на должность: '${val.position}'?`, 'Информация', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Отмена',
          type: 'info'
        }).then(() => {
          let self = this;
          let prefix = config.API_PREFIX;
          this.$gf.getOptions().then(options => {
            this.loading = true;
            options.params = { };
            let uid = val.uid
            self.$http.delete(`${prefix}vacancycandidate/${uid}`, options).then(response => {
              this.fetchData();
              this.vacancyDialogVisible = false;
              this.$message.error('Вы успешно отменили запись на конкурс');
            }).catch(data => {
              this.loading = false;
              self.$gf.checkError(data)
            });

          }).catch(err => this.$gf.catchOptions());
        }).catch(() => {

        });
      },
      solution(vacancy, candidate, status) {
        let word = status ? 'принять' : 'отклонить';
        this.$confirm(`Вы действительно хотите ${word} заявку?`, 'Информация', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Отмена',
          type: 'info'
        }).then(() => {
          let self = this;
          let prefix = config.API_PREFIX;
          this.$gf.getOptions().then(options => {
            this.loading = true;
            options.params = { };
            let command = status ? 'accept': 'deny';
            self.$http.post(`${prefix}vacancy/${vacancy}/candidates/${candidate}/${command}`, [], options).then(response => {
              this.fetchData();
              this.loading = false;
            }).catch(data => {
              this.loading = false;
              self.$gf.checkError(data)
            });

          }).catch(err => this.$gf.catchOptions());
        }).catch(() => {

        });
      },
      downloadApplication(vacancy, candidate) {
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = { };
          self.$http.get(`${prefix}vacancy/${vacancy}/candidates/${candidate}/attachments/first`, options)
            .then(response => {
              window.location.href = `${prefix}vacancy/${vacancy}/candidates/${candidate}/attachments/first/${response.data}`;
            })
            .catch(data => self.$gf.checkError(data));
          }).catch(err => this.$gf.catchOptions());
      },
      changeSearchValue(value) {
        this.fetchData(value)
      },
      open(vacancy, candidate) {
        if(vacancy, candidate) {
          //this.$router.push(config.RESUME_URL + '/' + value);
          this.$router.push(`/vacancysolution/${vacancy}/candidate/${candidate}`);
        }
      },
      fetchData(value) {
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          this.loading = true;
          ///VACANCIES
          let candidateGet = value ? `${prefix}vacancycandidate/?search=${value}` : `${prefix}vacancycandidate/?search=`
          let operatorGet = value ? `${prefix}vacancy/search/?input=${value}` : `${prefix}vacancy`;
          let get = this.isCandidate ? candidateGet : operatorGet;
          self.$http.get(get, options)
            .then(response => {
              self.vacancies = response.data;
              self.loading = false;
              if(self.vacancies && self.vacancies.length)
                self.handleVacancySelect(self.vacancies[0]);
            })
            .catch(data => {
              self.$gf.checkError(data);
              self.loading = false;
            });
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      fetchCombos(value) {
        /*if(!this.isCandidate) {
          this.loading = true;
          let self = this;
          let prefix = config.API_PREFIX;
          this.$gf.getOptions().then(options => {
            options.params = {
            };
            ///COMBOS
            self.$http.get(`${prefix}vacancy/statuses`, options)
              .then(response => {
                self.statuses = response.data;
                self.loading = false;
              })
              .catch(data => {
                self.$gf.checkError(data);
                self.loading = false;
              });
              self.$http.get(`${prefix}vacancy/comittees`, options)
                .then(response => {
                  self.comittees = response.data;
                  self.loading = false;
                })
                .catch(data => {
                  self.$gf.checkError(data);
                  self.loading = false;
                });
              self.loading = false;
          }).catch(err => {
            this.$gf.catchOptions();
            this.loading = false;
          });
        }*/
      },
      checkIsCandidate() {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          self.$http.get(`${prefix}calendar/candidate`, options)
            .then(response => {
              this.isCandidate = response.data;
              this.fetchCombos();
              this.fetchData(this.search);
            })
            .catch(data => {
              self.$gf.checkError(data);
              this.loading = false;
            });
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      showApplication(guid) {
        //window.open(`../docviewer/1/uid/${guid}`);
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///DOC
          let url = `${prefix}vacancycandidate/${guid}/application`;
          if(url) {
            self.$http.get(url, options)
              .then(response => {
                let rawHtml = response.data;
                self.loading = false;

            	  var pdf = new jsPDF('p', 'pt', 'letter');
                pdf.filename = 'Заявление.pdf';
                pdf.margin = [10, 10, 10, 10];

            	  html2pdf(rawHtml, pdf, function(pdf){
                  self.loading = true;
                  pdf.save();
                  self.loading = false;
            	  });
              })
              .catch(data => {
                self.$gf.checkError(data);
                self.loading = false;
              });
          }
          self.loading = false;
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      acceptAttachment() {
        //this.uploadDocs();
      },
      cancelAttachment() {
        /*this.fileList = [];
        this.attachmentToUpload = null;
        this.docDialogVisible = false;*/
      },
      uploadDocs() {
        /*if(true) {
          this.$gf.getOptions().then(options => {
            this.loading = true;
            options.params = { };
            this.uploadRequestHeaders = options.headers;
            let self = this;
            let prefix = config.API_PREFIX;
            self.$http.post(`${prefix}vacancycandidate/${this.vacancyToEnroll}`, [], options).then(response => {
              this.$refs.upload.submit();
              this.fetchData();
              this.vacancyDialogVisible = false;
              this.loading = false;
            }).catch(data => {
              this.loading = false;
              self.$gf.checkError(data)
            });
          }).catch(err => this.$gf.catchOptions());
        } else {
          this.$message({
             message: 'Заполните полностью анкету и прикрепите к ней все необходимые документы',
             type: 'warning'
          });
        }*/
      },
      uploadSuccess(response, file, fileList) {
        /*this.loading = true;
        this.fileList = [];
        this.attachmentToUpload = null;
        this.docDialogVisible = false;
        this.loading = false;*/
      },
      uploadError(err, file, fileList) {
        //this.loading = false;
      },
      beforeUpload(file) {
        /*let ext = extension.getExtension(file.name);
        ext = ext ? ext.toLowerCase() : ext;
        const isImage = ext && (ext === 'jpeg' || ext === 'jpg' || ext === 'png' || ext === 'pdf');
        const isLt5Mb = file.size / 1024 / 1024 <= 5;
        if (!isImage) {
          this.$message.error('Документ должен быть в формате jpg/jpeg/png/pdf');
        }
        if (!isLt5Mb) {
          this.$message.error('Размер документа должен быть меньше 5MB');
        }
        return isImage && isLt5Mb;*/
      },
      changeFileList(file, fileList) {
        /*let add = this.beforeUpload(file);
        if(!add) {
          fileList.splice(-1, 1);
        } else {
          if(fileList && fileList.length > 1) {
              this.$message.error('Количество документов не должно превышать 1');
              fileList.splice(-1, 1);
          }
        }*/
      },
      getLabelById(array, id) {
        return grid.getLabelById(array, id);
      },
      getLabelByCode(array, code) {
        return grid.getLabelByCode(array, code);
      },
      formatDate(d) {
        return grid.formatDate(d);
      },
      formatDateWithHoursAndMinutes(d) {
        return grid.formatDateWithHoursAndMinutes(d);
      },
      resize() {
        let height = layout.getParentClientHeight();
        if(height)
          this.resultsHeight = height - 30;
        else
          this.resultsHeight = null;
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
    },
    created() {
      window.addEventListener('resize', this.resize);
      this.checkIsCandidate();
      //this.fetchCombos();
    }
  }

</script>

<style scoped>
  .vacancy {
    height: calc(100% - 20px);
    background: #eef1f6;
    border: 1px solid #d1dbe5;
  }
  .middle-aligned {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .grid-text-overflow {
    /*overflow:hidden;
    display:inline-block;*/
    /*margin-left: 10px -- it s for items with icons*/
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .left-add-info {
    text-align: right;
    font-weight: bold;
    padding: 0px 10px;
  }
  .right-add-info {
    padding: 0px 10px;
  }
</style>
<style>
  .el-table .cell {
    word-break: normal !important;
  }
  .el-picker-panel {
    min-width: 350px !important;
  }
  .el-upload {
    width: 100% !important;
  }
  .el-upload-dragger {
    width: 100% !important;
    min-width: 360px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/personalarea/vacancy.vue